// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__244f2"};